export const rebrandColors = {
  // Greys
  iron: '#161617',
  shadow: '#747676',
  disableGrey: '#939595',
  silver: '#d2d2d3',
  mist: '#efefef',
  cloudySky: '#f5f7f7',

  // Orange
  electricOrange: '#f45d48',
  electricOrangeHover: '#e6503b',
  humanOrange: '#ff8d6d',
  peach: '#ffebde',
  orangeCream: '#fff4ee',
  flushOrange: '#fc8700',

  // Blue
  trustedBlue: '#021d5a',
  trustedBlueHover: '#091b45',
  electricBlue: '#2549ef',
  electricBlueHover: '#0829bc',
  powderBlue: '#d2e8f7',
  skyBlue: '#e9f3fe',
  skyBlueHover: '#c2ddef',
  roberto: '#4979FC',

  // Green
  greenBean: '#57af3c',
} as const;

export const colors = {
  // Helpers
  white: '#fff',
  black: '#000',

  // Greys
  almostBlack: '#2c2e2f',
  battleship: '#484949',
  boulder: '#7a7979',
  silverSandAlt: '#a0a0a0', // accessible Gray
  silverSand: '#bfc3c3',
  whiteSmoke: '#eaeaea',
  fog: '#f0f0f0',
  snow: '#f8f8f8',

  // Orange
  trafficCone: '#f60',
  trafficConeDark: '#bd4f27',
  trafficCodeMed1: '#f48438',
  trafficConeMed2: '#ffa366',
  trafficConeLight: '#ffc299',

  // Blue
  taosSky: '#09c',
  taosSkyDark: '#007399',
  taosSkyMed1: '#33aad6',
  taosSkyMed2: '#66c2e0',
  taosSkyLight: '#99d6eb',
  taosSkyLightest: '#e2f5fc',

  // Green
  kermit: '#6bb220',
  kermitDark: '#508518',
  kermitMed1: '#89c14d',
  kermitMed2: '#a6d179',
  kermitLight: '#c4e0a6',

  // Teal
  bluebee: '#4dc2be',
  bluebeeDark: '#3a928f',
  bluebeeMed1: '#71cecb',
  bluebeeMed2: '#94dad8',
  bluebeeLight: '#b8e7e5',

  // Pink
  tutu: '#f13c68',
  tutuDark: '#b52d53',
  tutuMed1: '#f4638b',
  tutuMed2: '#f78aa8',
  tutuLight: '#f9b1c5',

  // Other
  lemonade: '#fc0',
  recordRed: '#f00',
  darkBlue: '#244c5a',

  boxShadow: 'rgba(0, 0, 0, 0.16)',
  boxShadowLight: 'rgba(0, 0, 0, 0.06)',
  boxShadowDark: 'rgba(0,0,0,0.25)',

  modalBackground: 'rgb(0 0 0 / 60%)',

  activeShadow: 'rgba(0, 153, 204, 0.44)',
  ...rebrandColors,
} as const;

export type ColorName = keyof typeof colors;
export type RebrandColor = keyof typeof rebrandColors;
export type Color = (typeof colors)[ColorName];
